import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { KindService } from 'app/services/models/kind.service';
import { VaultService } from 'app/services/models/vault.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-vault-dialog',
  templateUrl: './create-vault-dialog.component.html',
  styleUrls: ['./create-vault-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateVaultDialogComponent implements OnInit {
  @Input() data: { id: number; title: string; description: string; kindId: number; };
  vaultForm: FormGroup;
  kinds: any[] = [];
  deleteMessage: any;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private kindService: KindService,
    private vaultService: VaultService,
    private toastrService: ToastrService,
    private router:Router,
    public authService:AuthService
  ) {
    this.vaultForm = this.fb.group({
      title: ['', Validators.required],
      description: [null],
      kind: [null, Validators.required]
    });
  }

  patchFormValues() {
    const selectedKind = this.kinds.find(k => k.id === this.data.kindId);
    this.vaultForm.patchValue({
      title: this.data.title,
      description: this.data.description,
      kind: selectedKind
    });
  }

  eventDelete(){
    this.closeModal();
    this.router.navigate(['/admin/vault']);
  }

  async ngOnInit() {
    console.log(this.data);
    if (this.data) {
      this.patchFormValues();
    }
    await this.getAllKinds();
    this.deleteMessage = "Seçili hesabı kalıcı olarak silmek istediğinizden eminmisiniz?"
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 50, 7);
    console.log(data);
    this.kinds = data.types;
    if (this.data) {
      this.patchFormValues();
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async save() {
    if (this.vaultForm.invalid) {
      this.vaultForm.markAllAsTouched();
      return;
    }


    if (this.data) {
      const data = await this.vaultService.updateVault(
        this.data.id,
        this.vaultForm.value.title,
        this.vaultForm.value.description,
        this.vaultForm.value.kind.id
      );
      if (data.status == true) {
        this.vaultService.sendEvent(true);
        this.toastrService.success(data.message);
      }
      else {
        this.toastrService.error(data.message);
      }
    } else {
      // Yeni veri ekleme işlemi yap
      const data = await this.vaultService.createVault(
        this.vaultForm.value.title,
        this.vaultForm.value.description,
        this.vaultForm.value.kind.id
      );
      if (data.status == true) {
        this.vaultService.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }

    this.activeModal.close(true);
  }

  hasPermission(): boolean {
    if (this.data) {
        return this.authService.isEndpointStatus('PUT.Updateing.UpdateVault');
    } else {
        return this.authService.isEndpointStatus('POST.Writing.CreateVault');
    }
}
}
